import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useForm } from "react-hook-form";
import FormInputField from "@/components/lib/from-input-field";
import { Input } from "@/components/lib/Form";
import { Form } from "@/components/ui/form";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

export function CreateNewFollowNotesDialog({ isOpen, onClose }) {
  const form = useForm({
    resolver: zodResolver(followUpSchema),
    defaultValues: {
      emploayId: "",
      transport: "",
      medical: "",
      mobileAllowance: "",
      bonus: "",
    },
  });

  const addSalary = (data) => {
    console.log(data);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <div className="py-5 flex flex-col">
          <DialogTitle className="text-lg absolute top-4 font-medium">
            Creating New Follow Up & Notes
          </DialogTitle>
          <Separator className="mt-4" />
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(addSalary)}
              className="flex flex-col gap-5 mt-5"
            >
              <FormInputField
                name={"emploayId"}
                style="bg-cblack7"
                placeholder={"Select Date"}
                form={form}
                label={"Date"}
                type="date"
              />

              <Input
                name="transport"
                style="bg-cblack7 !h-10"
                form={form}
                label={"Time"}
                type="time"
              />
              <FormInputField
                name="gender"
                style="bg-cblack7"
                placeholder={"Select Preference"}
                form={form}
                type="select"
                selectOption={[
                  {
                    label: "Call",
                    value: "male",
                  },
                  { label: "Phone", value: "Shaff" },
                ]}
                label={"Contact Preference"}
                required={true}
              />
              <FormInputField
                name={"notes"}
                style="bg-cblack7 h-24"
                placeholder={"Write notes here..."}
                form={form}
                label={"Notes"}
                type="textarea"
              />

              <Button className="bg-cyellow w-full text-cblack">Confirm</Button>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  );
}

const followUpSchema = z.object({
  emploayId: z.string().min(1, "Emploay name is required"),
  transport: z.string().min(1, "Required"),
  medical: z.string().min(1, "Required"),
  bonus: z.string().min(1, "Required"),
  mobileAllowance: z.string().min(1, "Required"),
});
